import React, { useEffect, useState } from "react";
import { Progress } from "@/components/ui/progress";
import { Loader2, FileSearch } from "lucide-react";

const STEPS = ["Leser dokumentet…", "Finner leverandør og beløp…", "Henter KID og kontonummer…", "Sjekker duplikater…", "Kontrollerer kontonummer…", "Ferdigstiller…"];

export const ProcessingState = ({ filename, compact = false }) => {
  const [step, setStep] = useState(0);
  const [progress, setProgress] = useState(8);

  useEffect(() => {
    const t1 = setInterval(() => setStep((s) => (s + 1) % STEPS.length), 1100);
    const t2 = setInterval(() => setProgress((p) => (p < 92 ? p + Math.max(1, Math.round((92 - p) / 12)) : p)), 400);
    return () => {
      clearInterval(t1);
      clearInterval(t2);
    };
  }, []);

  return (
    <div className={compact ? "flex items-center gap-3" : "rounded-xl border bg-card p-6"} data-testid="processing-state">
      {!compact && (
        <div className="flex items-center gap-3 mb-4">
          <div className="h-10 w-10 rounded-lg bg-accent text-accent-foreground flex items-center justify-center">
            <FileSearch className="h-5 w-5" />
          </div>
          <div>
            <p className="font-medium">{filename || "Behandler dokument"}</p>
            <p className="text-sm text-muted-foreground">Dette tar vanligvis 3–10 sekunder.</p>
          </div>
        </div>
      )}
      <div className="flex-1">
        <Progress value={progress} className="h-2" />
        <div className="mt-2 flex items-center gap-2 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span aria-live="polite">{STEPS[step]}</span>
        </div>
      </div>
    </div>
  );
};
